import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { sessionIsAdmin } from '../../utils/adminAuth';

const ADMIN_HOME = '/admin/overview';

/**
 * Platform admin uses the same login as collectors, then stays on the admin portal only.
 * Any non-/admin route while admin is signed in is redirected to the dashboard.
 */
export default function AdminSessionGate() {
    const { user } = useContext(UserContext);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!sessionIsAdmin(user)) return;
        if (location.pathname.startsWith('/admin')) return;
        navigate(ADMIN_HOME, { replace: true });
    }, [user, location.pathname, navigate]);

    return null;
}
